<template>
  <div>
    <div class="d-flex justify-content-end p-3 pb-0">
      <button
        class="btn btn-sm btn-outline-secondary"
        @click="showCortesiaModal = true"
      >
        <i class="fa-solid fa-gift me-1"></i>
        Dar Psiapp+ de cortesia
      </button>
    </div>
    <div class="subscription-list">
      <div
        v-for="elem in item.subscriptions"
        :key="elem.id"
        class="subscription-row"
        @click="goToDetail(elem.id)"
      >
        <div class="sub-col col-status">
          <span class="label">Status</span>
          <span class="badge" :class="statusBadgeClass(elem)">{{ elem.formatted_status }}</span>
        </div>
        <div class="sub-col col-date">
          <span class="label">Início</span>
          <span>{{ elem.formatted_start_date }}</span>
        </div>
        <div class="sub-col col-date">
          <span class="label">Cancelamento</span>
          <span :class="elem.canceled_at ? 'text-danger' : ''">{{ elem.formatted_canceled_at }}</span>
        </div>
        <div class="sub-col col-periodo">
          <span class="label">Período</span>
          <span>{{ elem.formatted_current_period_start }} - {{ elem.formatted_current_period_end }}</span>
        </div>
        <div class="sub-col col-plano">
          <span class="label">Plano</span>
          <strong :class="{ 'text-plus': isPlusPlan(elem) }">{{ elem.formatted_plan_frequency }}</strong>
        </div>
        <div class="sub-col col-valor">
          <span class="label">Valor</span>
          <strong :class="{ 'text-plus': isPlusPlan(elem) }">{{ elem.formatted_unit_amount }}</strong>
        </div>
        <div class="d-flex align-items-center gap-2 ms-auto">
          <button
            v-if="isCourtesyPlan(elem)"
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click.stop="handleRemovePsiappPlus(elem)"
          >
            <i class="fa-solid fa-crown me-1"></i> Remover Psiapp+
          </button>
          <a
            v-if="elem.subscription_id"
            :href="stripeSubscriptionLink(elem)"
            target="_blank"
            class="btn btn-sm btn-outline-dark"
            @click.stop
          >
            <i class="fa-brands fa-stripe me-1"></i> Ver no Stripe
          </a>
          <router-link
            :to="`${$paths.subscriptions.detail}/${elem.id}`"
            class="btn btn-sm btn-primary"
            @click.native.stop
          >
            <i class="fa-solid fa-eye me-1"></i> Ver detalhes
          </router-link>
        </div>
      </div>
    </div>

    <!-- Modal: Dar assinatura de cortesia -->
    <div
      v-if="showCortesiaModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0,0,0,0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa-solid fa-gift me-2 text-success"></i>
              Dar Psiapp+ de cortesia
            </h5>
            <button type="button" class="btn-close" @click="closeCortesiaModal"></button>
          </div>
          <div class="modal-body">
            <p class="text-muted mb-4">
              O psicólogo <strong>{{ item.name }}</strong> terá acesso completo ao
              Psiapp+ sem ser cobrado durante o período de cortesia.
            </p>

            <label class="form-label fw-bold mb-2">Duração</label>
            <div class="cortesia-options mb-3">
              <button
                type="button"
                class="cortesia-option"
                :class="{ active: cortesiaForm.type === 'months' }"
                @click="cortesiaForm.type = 'months'"
              >
                <i class="fa-solid fa-calendar-days"></i>
                <div class="opt-title">Por período</div>
                <div class="opt-sub">Número de meses</div>
              </button>
              <button
                type="button"
                class="cortesia-option"
                :class="{ active: cortesiaForm.type === 'forever' }"
                @click="cortesiaForm.type = 'forever'"
              >
                <i class="fa-solid fa-infinity"></i>
                <div class="opt-title">Para sempre</div>
                <div class="opt-sub">Sem data de término</div>
              </button>
            </div>

            <div v-if="cortesiaForm.type === 'months'" class="mb-3">
              <label class="form-label">Quantos meses?</label>
              <input
                type="number"
                class="form-control"
                v-model.number="cortesiaForm.months"
                min="1"
                max="120"
                placeholder="Ex: 3"
              />
            </div>

            <div class="cortesia-confirm">
              <div class="form-check mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="confirmCortesia"
                  v-model="cortesiaForm.confirmed"
                />
                <label class="form-check-label" for="confirmCortesia">
                  Confirmo a concessão de cortesia
                  <strong>
                    {{
                      cortesiaForm.type === 'forever'
                        ? 'por tempo indeterminado'
                        : `por ${cortesiaForm.months || 0} mês(es)`
                    }}</strong
                  >
                  para <strong>{{ item.name }}</strong>.
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeCortesiaModal">
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!canSubmitCortesia || submittingCortesia"
              @click="handleGrantCortesia"
            >
              <span v-if="submittingCortesia">
                <i class="fa-solid fa-spinner fa-spin me-1"></i> Processando...
              </span>
              <span v-else>
                <i class="fa-solid fa-check me-1"></i> Confirmar cortesia
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "PsiDetailSubscriptions",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showCortesiaModal: false,
      submittingCortesia: false,
      cortesiaForm: {
        type: "months",
        months: 1,
        confirmed: false,
      },
    };
  },
  mounted() {
    this.$eventBus.$on("psiDetail:openCortesia", this.openCortesiaModal);
  },
  beforeDestroy() {
    this.$eventBus.$off("psiDetail:openCortesia", this.openCortesiaModal);
  },
  computed: {
    canSubmitCortesia() {
      if (!this.cortesiaForm.confirmed) return false;
      if (this.cortesiaForm.type === "forever") return true;
      return this.cortesiaForm.months && this.cortesiaForm.months >= 1;
    },
  },
  methods: {
    openCortesiaModal() {
      this.showCortesiaModal = true;
    },
    closeCortesiaModal() {
      this.showCortesiaModal = false;
      this.cortesiaForm.type = "months";
      this.cortesiaForm.months = 1;
      this.cortesiaForm.confirmed = false;
    },
    async handleGrantCortesia() {
      this.submittingCortesia = true;
      try {
        if (this.cortesiaForm.type === "forever") {
          await this.$userService.givePremium(this.item.id);
        } else {
          await this.$userService.network.post(
            `api/subscriptions/gift-non-subscriber`,
            {
              user_id: this.item.id,
              months: this.cortesiaForm.months,
            }
          );
        }
        this.$eventBus.$emit("showToast", {
          title: "Cortesia concedida",
          msg:
            this.cortesiaForm.type === "forever"
              ? `Assinatura de cortesia permanente (Psiapp+) concedida a ${this.item.name}.`
              : `Assinatura de cortesia de ${this.cortesiaForm.months} mês(es) concedida a ${this.item.name}.`,
        });
        this.closeCortesiaModal();
        this.$emit("refresh");
      } catch (error) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: error.message || "Erro ao conceder assinatura de cortesia.",
        });
      } finally {
        this.submittingCortesia = false;
      }
    },
    stripeSubscriptionLink(elem) {
      const acctId = process.env.VUE_APP_STRIPE_PLATFORM_ACCOUNT_ID;
      const mid =
        process.env.VUE_APP_ENV === "prod"
          ? "subscriptions"
          : "test/subscriptions";
      return `https://dashboard.stripe.com/${acctId}/${mid}/${elem.subscription_id}`;
    },
    statusBadgeClass(elem) {
      if (
        elem.status === "canceled" &&
        elem.trial_end &&
        this.$moment(elem.trial_end).isAfter(this.$moment())
      ) {
        return "bg-primary";
      }
      if (elem.status === "active" && elem.canceled_at) {
        return "bg-warning text-dark";
      }
      const classes = {
        active: "bg-success",
        trialing: "bg-primary",
        canceled: "bg-danger",
        past_due: "bg-warning text-dark",
        unpaid: "bg-warning text-dark",
        paused: "bg-secondary",
        incomplete: "bg-warning text-dark",
        incomplete_expired: "bg-danger",
      };
      return classes[elem.status] || "bg-secondary";
    },
    goToDetail(id) {
      this.$router.push(`${this.$paths.subscriptions.detail}/${id}`);
    },
    isPlusPlan(elem) {
      return elem.plan?.slug === 'psiapp-mais-pro';
    },
    isCourtesyPlan(elem) {
      return elem.plan?.slug === 'free-admin-premium';
    },
    async handleRemovePsiappPlus(elem) {
      const ok = confirm(
        `Deseja remover o Psiapp+ de cortesia de ${this.item.name}? Ao remover, o psi perderá os benefícios da conta premium.`
      );
      if (!ok) return;
      try {
        await this.$userService.removePremium(this.item.id);
        this.$eventBus.$emit("showToast", {
          title: "Psiapp+ removido",
          msg: `${this.item.name} não é mais um assinante Psiapp+.`,
        });
        this.$emit("refresh");
      } catch (error) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: error.message || "Erro ao remover Psiapp+.",
        });
      }
    },
  },
});
</script>

<style scoped>
.cortesia-options {
  display: flex;
  gap: 12px;
}

.cortesia-option {
  flex: 1;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  background-color: #fff;
  padding: 16px 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.15s;
}

.cortesia-option:hover {
  border-color: #ced4da;
  background-color: #f8f9fa;
}

.cortesia-option.active {
  border-color: #198754;
  background-color: #f0fdf4;
}

.cortesia-option i {
  font-size: 1.4rem;
  color: #adb5bd;
  margin-bottom: 8px;
}

.cortesia-option.active i {
  color: #198754;
}

.cortesia-option .opt-title {
  font-weight: 600;
  color: #212529;
  font-size: 0.9rem;
}

.cortesia-option .opt-sub {
  font-size: 0.75rem;
  color: #6c757d;
}

.cortesia-confirm {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 0.875rem;
}

.subscription-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.subscription-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}

.subscription-row:hover {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.sub-col {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}

.sub-col .label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sub-col span:not(.label):not(.badge),
.sub-col strong {
  font-size: 0.875rem;
  color: #495057;
}

/* Fixed column widths for alignment */
.col-status {
  width: 100px;
}

.col-date {
  width: 110px;
  white-space: nowrap;
}

.col-periodo {
  width: 180px;
}

.col-plano {
  width: 140px;
  flex: 1;
}

.col-valor {
  width: 80px;
}

.text-plus {
  color: #2563eb !important;
}
</style>
